import { makeChartComp } from '../../util/makeChartComp';
var CirclePackingChart = makeChartComp('CirclePacking');
export default CirclePackingChart;
